import React from 'react';
import Square from './square.svg';

const SquareLogo = () => (
  <img src={Square} alt="Logo" width={100} height={100} />
);

export default SquareLogo;
